import { ChangePassword } from '../../modules/auth';
import { Dashboards } from '../../modules/dashboards';
import { Resources } from '../../modules/resources';
import { AddUser, EditUser, Users } from '../../modules/users';
import { AppFeature, AppRoute, Role } from '../enum';
import { RouteType } from '../models';
import { PATHS } from './paths.constant';

export const APP_ROUTES: { [key in AppRoute]: RouteType } = {
  [AppRoute.DocumentsHome]: {
    routeKey: 'Documents',
    name: 'Documents',
    path: PATHS.DocumentsHome,
    Component: Resources,
  },
  [AppRoute.Documents]: {
    routeKey: 'Documents',
    name: 'Documents',
    path: PATHS.Documents,
    Component: Resources,
  },
  [AppRoute.UserManagement]: {
    routeKey: 'User Management',
    name: 'User Management',
    path: PATHS.UserManagement,
    Component: Users,
    requiredRoles: [Role.RestrictedAdmin, Role.FullAdmin],
    exact: true,
  },
  [AppRoute.ChangePassword]: {
    routeKey: 'Change Password',
    name: 'Change Password',
    path: PATHS.ChangePassword,
    Component: ChangePassword,
  },
  [AppRoute.AddUser]: {
    routeKey: 'Add User',
    name: 'Add User',
    path: PATHS.AddUser,
    Component: AddUser,
    requiredRoles: [Role.RestrictedAdmin, Role.FullAdmin],
    exact: true,
  },
  [AppRoute.EditUser]: {
    routeKey: 'Edit User',
    name: 'Edit User',
    path: PATHS.EditUser,
    Component: EditUser,
    requiredRoles: [Role.RestrictedAdmin, Role.FullAdmin],
    exact: true,
  },
  [AppRoute.PendingApproval]: {
    routeKey: 'Documents',
    name: 'Pending Approval',
    path: PATHS.PendingApproval,
    Component: Resources,
    requiredRoles: [Role.User, Role.RestrictedAdmin, Role.FullAdmin],
    exact: true,
    requiredFeature: AppFeature.PendingApproval,
  },
  [AppRoute.Favourites]: {
    routeKey: 'Documents',
    name: 'Favourites',
    path: PATHS.Favourites,
    Component: Resources,
    exact: true,
  },
  [AppRoute.Recents]: {
    routeKey: 'Recents',
    name: 'Recents',
    path: PATHS.Recents,
    Component: Resources,
    exact: true,
  },
  [AppRoute.Dashboards]: {
    routeKey: 'Dashboards',
    name: 'Dashboards',
    path: PATHS.Dashboards,
    Component: Dashboards,
  },
  [AppRoute.DashboardsWorkbooks]: {
    routeKey: 'Dashboards',
    name: 'Dashboards',
    path: PATHS.DashboardsWorkbooks,
    Component: Dashboards,
  },
  [AppRoute.DashboardsSearch]: {
    routeKey: 'Dashboards',
    name: 'Dashboards',
    path: PATHS.DashboardsSearch,
    Component: Dashboards,
  },
  [AppRoute.Uploads]: {
    routeKey: 'Documents',
    name: 'Uploads',
    path: PATHS.Uploads,
    Component: Resources,
    exact: true,
  },
};
